import { useEffect } from "react";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { AddressesView } from "@/Patient/Components/Profile/ContactComponents/AddressesView";
import { EmailsView } from "@/Patient/Components/Profile/ContactComponents/EmailsView";
import { PhonesView } from "@/Patient/Components/Profile/ContactComponents/PhonesView";
import { relativeStore } from "../Stores/RelativeStore";

function ContactsView(): JSX.Element {
    const relative = relativeStore.GetCurrent();
    const { getText } = useTranslation();

    useEffect(() => {
        $(window).trigger("resize");
    });

    const sortedAddress = relative.Addresses.sortByPropertyDesc(p => p.IsPreferred);
    const sortedPhones = relative.Phones.sortByPropertyDesc(p => p.IsPreferred);

    return (
        <div className="tabComponent contacts">
            <div
                className="tabComponent-main patient-prof"
                data-cy="patientProfile-contacts-view"
            >
                <div className="block separated">
                    <div className="flex-container heading">
                        <h3 className="thin-font">
                            {getText("ContactInformationLabel")}
                        </h3>
                    </div>

                    <div className="patient-profile fxd-wdth-container edit padding-sm-bottom">
                        <div className="tb">
                            <div className="tbc left">
                                <AddressesView addresses={sortedAddress} />
                            </div>
                            <div className="tbc right">
                                <PhonesView phones={sortedPhones} />
                                <EmailsView
                                    doNotEmail={relative.DoNotEmail}
                                    emails={relative.Emails}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tabComponent-footer ws-subfooter patient-profile">
                <div className="tb patient-profile-footer">
                    <div className="tbc pull-right">
                        <ButtonControl
                            className="btn btn-primary pull-right"
                            onClick={() => sessionStore.dispatch(LocalOperations.Relative.EditProfile)}
                            label={getText("EDITLabel")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { ContactsView };
